import { type IContent } from "@kunduz/data-access-cms-api";
import React, { ReactElement } from "react";
import styles from "./userReviews.module.scss";
import { PlanDetailUserReviews } from "../planDetailV2";

export const UserReviews = (props: Props): ReactElement => {
  return (
    <section className={styles.base} id={props.id}>
      <div className={styles.wrapper}>
        <div className={styles.left}>
          <div className={styles.sticky}>
            <PlanDetailUserReviews.Title>
              {props.componentData.title}
            </PlanDetailUserReviews.Title>
            <PlanDetailUserReviews.MetaAndPercWrapper>
              <PlanDetailUserReviews.Meta
                rating={props.componentData?.rating}
                reviewLabel={props.componentData?.review}
              />
              <PlanDetailUserReviews.Percentages
                five={props.componentData.fifth_star_percentage}
                four={props.componentData.fourth_star_percentage}
                three={props.componentData.third_star_percentage}
                two={props.componentData.second_star_percentage}
                one={props.componentData.first_star_percentage}
              />
            </PlanDetailUserReviews.MetaAndPercWrapper>
          </div>
        </div>
        <div className={styles.right}>
          <PlanDetailUserReviews.ReviewCardWrapper>
            {props.reviews?.map(
              (
                x: IContent.PlanDetailV2ReviewData["items"]["results"][0],
                i: number,
              ) => (
                <PlanDetailUserReviews.ReviewCard
                  key={`review_card_${x.order}_${i}`}
                  title={x.user}
                  description={x.description}
                  imageUrl={x.image}
                  rating={x.rating}
                  reviewTitle={x.message_title}
                  reviewDesc={x.message}
                  onShowMoreClicked={() => props.onShowMoreClicked(x.user)}
                />
              ),
            )}
          </PlanDetailUserReviews.ReviewCardWrapper>

          {props.nextUrl && (
            <PlanDetailUserReviews.LoadMoreButton
              onClick={props.onLoadMoreClicked}
              disabled={props.loading}
            >
              {props.loadMoreLabel}
            </PlanDetailUserReviews.LoadMoreButton>
          )}
        </div>
      </div>
    </section>
  );
};

interface Props {
  id?: string;
  componentData: IContent.UserReviewComponentData;
  reviews: IContent.PlanDetailV2ReviewData["items"]["results"] | undefined;
  onLoadMoreClicked: () => void;
  onShowMoreClicked: (user: any) => void;
  nextUrl?: string;
  loading: boolean;
  loadMoreLabel: string;
}
